import type {
  InboundInfo,
  InboundItem,
} from "@/hooks/roster-craete/useRosterSchedule";
import { isAssignmentBarSuppressedReason } from "@/services/assignment/computeAssignmentStarts";
import { inboundItemsFromInboundField } from "@/services/assignment/inboundForView";

export type NurseRowWithInboundState = {
  readonly is_inbound?: boolean | null;
  readonly inbound?: InboundInfo | readonly InboundItem[] | null;
  readonly assignments?: readonly InboundItem[] | null;
};

export function isDispatchAssignmentReason(reason: unknown): boolean {
  if (reason == null) return false;
  const value = String(reason).trim().toLowerCase();
  return value.includes("파견") || value.includes("dispatch");
}

export function isDispatchedDisplayRow(row: NurseRowWithInboundState): boolean {
  const assignmentItems = [
    ...inboundItemsFromInboundField(row.inbound ?? undefined),
    ...(row.assignments ?? []),
  ];
  return assignmentItems.some(
    (item) =>
      isDispatchAssignmentReason(item.reason) &&
      !isAssignmentBarSuppressedReason(item.reason)
  );
}

export function splitDispatchedRows<T extends NurseRowWithInboundState>(
  rows: readonly T[]
): {
  regularRows: T[];
  dispatchedRows: T[];
  displayRows: T[];
} {
  const regularRows: T[] = [];
  const dispatchedRows: T[] = [];

  for (const row of rows) {
    if (isDispatchedDisplayRow(row)) {
      dispatchedRows.push(row);
    } else {
      regularRows.push(row);
    }
  }

  return {
    regularRows,
    dispatchedRows,
    displayRows:
      dispatchedRows.length > 0 ? [...regularRows, ...dispatchedRows] : regularRows,
  };
}
